import React, { useEffect, useState } from 'react';

import { Spinner } from 'design-system/react';

import { useAppNavigate, useTaskCompletedToast } from '../../hooks';

interface OverlayProps {
  active: boolean;
}

export const CompletedTaskReaction: React.FC<OverlayProps> = ({ active }) => {
  const taskCompletedToast = useTaskCompletedToast();
  const navigate = useAppNavigate();
  const [activated, setActivated] = useState<boolean>(false);

  useEffect(() => {
    if (active && !activated) {
      setActivated(true);
      taskCompletedToast();
      setTimeout(() => navigate.back(), 300);
    }
  }, [activated, active, navigate, taskCompletedToast]);

  if (!active) {
    return null;
  }

  return (
    <div
      id="overlay"
      className="fixed inset-0 w-screen h-screen bg-black/60 z-(--z-modal) flex items-center justify-center"
    >
      <Spinner size="xl" className="text-white" />
    </div>
  );
};
